import { render, staticRenderFns } from "./bicduo.vue?vue&type=template&id=0e233cd6&scoped=true&"
import script from "./bicduo.vue?vue&type=script&lang=js&"
export * from "./bicduo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e233cd6",
  null
  
)

export default component.exports